var map = {
	"./TitansLeagueLogo.png": "f979",
	"./Wrath-Logo-Small.png": "a04d",
	"./alliance.png": "43f6",
	"./alliance_medium.png": "5ec6",
	"./alliance_min.png": "2757",
	"./armory/equipment_slots/ammo.png": "34e5",
	"./armory/equipment_slots/back.png": "a70c",
	"./armory/equipment_slots/backpack.png": "2697",
	"./armory/equipment_slots/bag.png": "37ac",
	"./armory/equipment_slots/body.png": "e4ba",
	"./armory/equipment_slots/chest.png": "c615",
	"./armory/equipment_slots/feet.png": "61aa",
	"./armory/equipment_slots/finger.png": "19ff",
	"./armory/equipment_slots/hands.png": "96c9",
	"./armory/equipment_slots/head.png": "7b64",
	"./armory/equipment_slots/item_frame.png": "8929",
	"./armory/equipment_slots/item_frame_hover.png": "7269",
	"./armory/equipment_slots/item_questionmark.png": "411b",
	"./armory/equipment_slots/legs.png": "3ac8",
	"./armory/equipment_slots/mainhand.png": "0a19",
	"./armory/equipment_slots/neck.png": "75a2",
	"./armory/equipment_slots/ranged.png": "0227",
	"./armory/equipment_slots/relic.png": "b74d",
	"./armory/equipment_slots/shield.png": "506c",
	"./armory/equipment_slots/shoulders.png": "71e6",
	"./armory/equipment_slots/tabard.png": "e2f2",
	"./armory/equipment_slots/trinket.png": "f826",
	"./armory/equipment_slots/waist.png": "f117",
	"./armory/equipment_slots/wrist.png": "d462",
	"./armory/misc/money-copper.gif": "75c0",
	"./armory/misc/money-gold.gif": "d676",
	"./armory/misc/money-silver.gif": "bf3b",
	"./armory/misc/socket_blue.gif": "4916",
	"./armory/misc/socket_meta.gif": "906e",
	"./armory/misc/socket_red.gif": "b970",
	"./armory/misc/socket_yellow.gif": "263e8",
	"./avatar_frame.png": "026f",
	"./avatars/Deathknight-bloodelf-f-70.gif": "4846",
	"./avatars/Deathknight-bloodelf-m-70.gif": "48e8",
	"./avatars/Deathknight-draenei-f-70.gif": "b3da",
	"./avatars/Deathknight-draenei-m-70.gif": "fbfa",
	"./avatars/Deathknight-dwarf-f-70.gif": "46bc",
	"./avatars/Deathknight-dwarf-m-70.gif": "9cd8",
	"./avatars/Deathknight-gnome-f-70.gif": "19e7",
	"./avatars/Deathknight-gnome-m-70.gif": "8fcf",
	"./avatars/Deathknight-human-f-70.gif": "6d4a",
	"./avatars/Deathknight-human-m-70.gif": "1b8c",
	"./avatars/Deathknight-nightelf-f-70.gif": "ed73",
	"./avatars/Deathknight-nightelf-m-70.gif": "28d7",
	"./avatars/Deathknight-orc-f-70.gif": "1677",
	"./avatars/Deathknight-orc-m-70.gif": "7310",
	"./avatars/Deathknight-tauren-f-70.gif": "c4dc",
	"./avatars/Deathknight-tauren-m-70.gif": "9ea8",
	"./avatars/Deathknight-troll-f-70.gif": "e5cc",
	"./avatars/Deathknight-troll-m-70.gif": "b748",
	"./avatars/Deathknight-undead-f-70.gif": "ac39",
	"./avatars/Deathknight-undead-m-70.gif": "895a",
	"./avatars/DemonHunter-bloodelf-f-110.gif": "41e2",
	"./avatars/DemonHunter-bloodelf-m-110.gif": "a56f",
	"./avatars/DemonHunter-nightelf-f-110.gif": "39db",
	"./avatars/DemonHunter-nightelf-m-110.gif": "8e9b",
	"./avatars/Druid-nightelf-f-1.gif": "a80e",
	"./avatars/Druid-nightelf-f-60.gif": "a5b1",
	"./avatars/Druid-nightelf-f-70.gif": "e706",
	"./avatars/Druid-nightelf-m-1.gif": "479c",
	"./avatars/Druid-nightelf-m-60.gif": "3db6",
	"./avatars/Druid-nightelf-m-70.gif": "f0c6",
	"./avatars/Druid-tauren-f-1.gif": "933d",
	"./avatars/Druid-tauren-f-60.gif": "0f5e",
	"./avatars/Druid-tauren-f-70.gif": "79e5",
	"./avatars/Druid-tauren-m-1.gif": "7468",
	"./avatars/Druid-tauren-m-60.gif": "f3aa",
	"./avatars/Druid-tauren-m-70.gif": "2714",
	"./avatars/Hunter-bloodelf-f-1.gif": "af64",
	"./avatars/Hunter-bloodelf-f-60.gif": "54a6",
	"./avatars/Hunter-bloodelf-f-70.gif": "f547",
	"./avatars/Hunter-bloodelf-m-1.gif": "3f67",
	"./avatars/Hunter-bloodelf-m-60.gif": "49d1",
	"./avatars/Hunter-bloodelf-m-70.gif": "d43b",
	"./avatars/Hunter-draenei-f-1.gif": "f7d5",
	"./avatars/Hunter-draenei-f-60.gif": "5439",
	"./avatars/Hunter-draenei-f-70.gif": "8d63",
	"./avatars/Hunter-draenei-m-1.gif": "6ec0",
	"./avatars/Hunter-draenei-m-60.gif": "b936",
	"./avatars/Hunter-draenei-m-70.gif": "c261",
	"./avatars/Hunter-dwarf-f-1.gif": "5927",
	"./avatars/Hunter-dwarf-f-60.gif": "a620",
	"./avatars/Hunter-dwarf-f-70.gif": "6557",
	"./avatars/Hunter-dwarf-m-1.gif": "ceca",
	"./avatars/Hunter-dwarf-m-60.gif": "21c7",
	"./avatars/Hunter-dwarf-m-70.gif": "430d",
	"./avatars/Hunter-nightelf-f-1.gif": "62fd",
	"./avatars/Hunter-nightelf-f-60.gif": "336e",
	"./avatars/Hunter-nightelf-f-70.gif": "e556",
	"./avatars/Hunter-nightelf-m-1.gif": "d244",
	"./avatars/Hunter-nightelf-m-60.gif": "3a8c",
	"./avatars/Hunter-nightelf-m-70.gif": "a7cf",
	"./avatars/Hunter-orc-f-1.gif": "d395",
	"./avatars/Hunter-orc-f-60.gif": "63bf",
	"./avatars/Hunter-orc-f-70.gif": "1f25",
	"./avatars/Hunter-orc-m-1.gif": "002e",
	"./avatars/Hunter-orc-m-60.gif": "0811",
	"./avatars/Hunter-orc-m-70.gif": "5385",
	"./avatars/Hunter-tauren-f-1.gif": "090b",
	"./avatars/Hunter-tauren-f-60.gif": "8a86",
	"./avatars/Hunter-tauren-f-70.gif": "17c0",
	"./avatars/Hunter-tauren-m-1.gif": "3cef",
	"./avatars/Hunter-tauren-m-60.gif": "0f76",
	"./avatars/Hunter-tauren-m-70.gif": "1826",
	"./avatars/Hunter-troll-f-1.gif": "f260",
	"./avatars/Hunter-troll-f-60.gif": "edcc",
	"./avatars/Hunter-troll-f-70.gif": "8d4f",
	"./avatars/Hunter-troll-m-1.gif": "7ceb",
	"./avatars/Hunter-troll-m-60.gif": "e162",
	"./avatars/Hunter-troll-m-70.gif": "7434",
	"./avatars/Mage-bloodelf-f-1.gif": "ef7d",
	"./avatars/Mage-bloodelf-f-60.gif": "0178",
	"./avatars/Mage-bloodelf-f-70.gif": "c2d2",
	"./avatars/Mage-bloodelf-m-1.gif": "84b1",
	"./avatars/Mage-bloodelf-m-60.gif": "0746",
	"./avatars/Mage-bloodelf-m-70.gif": "d181",
	"./avatars/Mage-draenei-f-1.gif": "b56b",
	"./avatars/Mage-draenei-f-60.gif": "d0c4",
	"./avatars/Mage-draenei-f-70.gif": "df8a",
	"./avatars/Mage-draenei-m-1.gif": "02b7",
	"./avatars/Mage-draenei-m-60.gif": "b65f",
	"./avatars/Mage-draenei-m-70.gif": "f0ef",
	"./avatars/Mage-gnome-f-1.gif": "5f43",
	"./avatars/Mage-gnome-f-60.gif": "5527",
	"./avatars/Mage-gnome-f-70.gif": "f03b",
	"./avatars/Mage-gnome-m-1.gif": "b904",
	"./avatars/Mage-gnome-m-60.gif": "0910",
	"./avatars/Mage-gnome-m-70.gif": "7f84",
	"./avatars/Mage-human-f-1.gif": "dfe4",
	"./avatars/Mage-human-f-60.gif": "7c17",
	"./avatars/Mage-human-f-70.gif": "5d4f",
	"./avatars/Mage-human-m-1.gif": "75ea",
	"./avatars/Mage-human-m-60.gif": "3f0e",
	"./avatars/Mage-human-m-70.gif": "ec3d",
	"./avatars/Mage-troll-f-1.gif": "2ddd",
	"./avatars/Mage-troll-f-60.gif": "31f7",
	"./avatars/Mage-troll-f-70.gif": "e975",
	"./avatars/Mage-troll-m-1.gif": "317a",
	"./avatars/Mage-troll-m-60.gif": "76b3",
	"./avatars/Mage-troll-m-70.gif": "fcdc",
	"./avatars/Mage-undead-f-1.gif": "2d6b",
	"./avatars/Mage-undead-f-60.gif": "c5f6",
	"./avatars/Mage-undead-f-70.gif": "0fe8",
	"./avatars/Mage-undead-m-1.gif": "58bf",
	"./avatars/Mage-undead-m-60.gif": "572a",
	"./avatars/Mage-undead-m-70.gif": "98e3",
	"./avatars/Paladin-bloodelf-f-1.gif": "7188",
	"./avatars/Paladin-bloodelf-f-60.gif": "89f2",
	"./avatars/Paladin-bloodelf-f-70.gif": "dd9f",
	"./avatars/Paladin-bloodelf-m-1.gif": "c4d0",
	"./avatars/Paladin-bloodelf-m-60.gif": "989f",
	"./avatars/Paladin-bloodelf-m-70.gif": "6110",
	"./avatars/Paladin-draenei-f-1.gif": "003b",
	"./avatars/Paladin-draenei-f-60.gif": "4793",
	"./avatars/Paladin-draenei-f-70.gif": "a900",
	"./avatars/Paladin-draenei-m-1.gif": "c0a6",
	"./avatars/Paladin-draenei-m-60.gif": "98fd",
	"./avatars/Paladin-draenei-m-70.gif": "2994",
	"./avatars/Paladin-dwarf-f-1.gif": "979f",
	"./avatars/Paladin-dwarf-f-60.gif": "ce7e",
	"./avatars/Paladin-dwarf-f-70.gif": "47a6",
	"./avatars/Paladin-dwarf-m-1.gif": "6216",
	"./avatars/Paladin-dwarf-m-60.gif": "f033",
	"./avatars/Paladin-dwarf-m-70.gif": "fbca",
	"./avatars/Paladin-human-f-1.gif": "c818",
	"./avatars/Paladin-human-f-60.gif": "9d66",
	"./avatars/Paladin-human-f-70.gif": "9e66",
	"./avatars/Paladin-human-m-1.gif": "8c29",
	"./avatars/Paladin-human-m-60.gif": "9e96",
	"./avatars/Paladin-human-m-70.gif": "afa2",
	"./avatars/Priest-bloodelf-f-1.gif": "7256",
	"./avatars/Priest-bloodelf-f-60.gif": "cbec",
	"./avatars/Priest-bloodelf-f-70.gif": "9510",
	"./avatars/Priest-bloodelf-m-1.gif": "1cc4",
	"./avatars/Priest-bloodelf-m-60.gif": "a7d2",
	"./avatars/Priest-bloodelf-m-70.gif": "2801",
	"./avatars/Priest-draenei-f-1.gif": "0699",
	"./avatars/Priest-draenei-f-60.gif": "042d",
	"./avatars/Priest-draenei-f-70.gif": "f36f",
	"./avatars/Priest-draenei-m-1.gif": "f96a",
	"./avatars/Priest-draenei-m-60.gif": "91eb",
	"./avatars/Priest-draenei-m-70.gif": "89aa",
	"./avatars/Priest-dwarf-f-1.gif": "1a1e",
	"./avatars/Priest-dwarf-f-60.gif": "c3ca",
	"./avatars/Priest-dwarf-f-70.gif": "2e5b",
	"./avatars/Priest-dwarf-m-1.gif": "41a8",
	"./avatars/Priest-dwarf-m-60.gif": "5a2b",
	"./avatars/Priest-dwarf-m-70.gif": "66d1",
	"./avatars/Priest-human-f-1.gif": "e3bf",
	"./avatars/Priest-human-f-60.gif": "7511",
	"./avatars/Priest-human-f-70.gif": "4129",
	"./avatars/Priest-human-m-1.gif": "ccc7",
	"./avatars/Priest-human-m-60.gif": "d1be",
	"./avatars/Priest-human-m-70.gif": "1726",
	"./avatars/Priest-nightelf-f-1.gif": "324e",
	"./avatars/Priest-nightelf-f-60.gif": "cb59",
	"./avatars/Priest-nightelf-f-70.gif": "59751",
	"./avatars/Priest-nightelf-m-1.gif": "0027",
	"./avatars/Priest-nightelf-m-60.gif": "0a2a",
	"./avatars/Priest-nightelf-m-70.gif": "513f",
	"./avatars/Priest-troll-f-1.gif": "74e0",
	"./avatars/Priest-troll-f-60.gif": "d6a2",
	"./avatars/Priest-troll-f-70.gif": "7b47",
	"./avatars/Priest-troll-m-1.gif": "b171",
	"./avatars/Priest-troll-m-60.gif": "6c41",
	"./avatars/Priest-troll-m-70.gif": "2c1b",
	"./avatars/Priest-undead-f-1.gif": "37d0",
	"./avatars/Priest-undead-f-60.gif": "6f5e",
	"./avatars/Priest-undead-f-70.gif": "56b0",
	"./avatars/Priest-undead-m-1.gif": "7092",
	"./avatars/Priest-undead-m-60.gif": "b365",
	"./avatars/Priest-undead-m-70.gif": "c984",
	"./avatars/Rogue-bloodelf-f-1.gif": "5656",
	"./avatars/Rogue-bloodelf-f-60.gif": "138f",
	"./avatars/Rogue-bloodelf-f-70.gif": "9b86",
	"./avatars/Rogue-bloodelf-m-1.gif": "36a3",
	"./avatars/Rogue-bloodelf-m-60.gif": "dd75",
	"./avatars/Rogue-bloodelf-m-70.gif": "a0d4",
	"./avatars/Rogue-drainei-m-70.gif": "0d09",
	"./avatars/Rogue-dwarf-f-1.gif": "d514",
	"./avatars/Rogue-dwarf-f-60.gif": "3ab0",
	"./avatars/Rogue-dwarf-f-70.gif": "165b",
	"./avatars/Rogue-dwarf-m-1.gif": "3f39",
	"./avatars/Rogue-dwarf-m-60.gif": "c388",
	"./avatars/Rogue-dwarf-m-70.gif": "0ca6",
	"./avatars/Rogue-gnome-f-1.gif": "b07c",
	"./avatars/Rogue-gnome-f-60.gif": "e480",
	"./avatars/Rogue-gnome-f-70.gif": "a62a",
	"./avatars/Rogue-gnome-m-1.gif": "72f4",
	"./avatars/Rogue-gnome-m-60.gif": "cf2e",
	"./avatars/Rogue-gnome-m-70.gif": "7a09",
	"./avatars/Rogue-human-f-1.gif": "f846",
	"./avatars/Rogue-human-f-60.gif": "622e",
	"./avatars/Rogue-human-f-70.gif": "0112",
	"./avatars/Rogue-human-m-1.gif": "3b4c",
	"./avatars/Rogue-human-m-60.gif": "70ea",
	"./avatars/Rogue-human-m-70.gif": "f91d",
	"./avatars/Rogue-nightelf-f-1.gif": "4f9f",
	"./avatars/Rogue-nightelf-f-60.gif": "4799",
	"./avatars/Rogue-nightelf-f-70.gif": "033a",
	"./avatars/Rogue-nightelf-m-1.gif": "d23c",
	"./avatars/Rogue-nightelf-m-60.gif": "0bc3",
	"./avatars/Rogue-nightelf-m-70.gif": "f7f5",
	"./avatars/Rogue-orc-f-1.gif": "4a75",
	"./avatars/Rogue-orc-f-60.gif": "58c5",
	"./avatars/Rogue-orc-f-70.gif": "ce75",
	"./avatars/Rogue-orc-m-1.gif": "5a63",
	"./avatars/Rogue-orc-m-60.gif": "7268",
	"./avatars/Rogue-orc-m-70.gif": "865b",
	"./avatars/Rogue-troll-f-1.gif": "f559",
	"./avatars/Rogue-troll-f-60.gif": "2678",
	"./avatars/Rogue-troll-f-70.gif": "58ae",
	"./avatars/Rogue-troll-m-1.gif": "cf6c",
	"./avatars/Rogue-troll-m-60.gif": "e2b1",
	"./avatars/Rogue-troll-m-70.gif": "1ffb",
	"./avatars/Rogue-undead-f-1.gif": "2e49",
	"./avatars/Rogue-undead-f-60.gif": "8727",
	"./avatars/Rogue-undead-f-70.gif": "e4ae",
	"./avatars/Rogue-undead-m-1.gif": "63d8",
	"./avatars/Rogue-undead-m-60.gif": "939a",
	"./avatars/Rogue-undead-m-70.gif": "d729",
	"./avatars/Shaman-draenei-f-1.gif": "bd39",
	"./avatars/Shaman-draenei-f-60.gif": "56d5",
	"./avatars/Shaman-draenei-f-70.gif": "999f",
	"./avatars/Shaman-draenei-m-1.gif": "5a8e",
	"./avatars/Shaman-draenei-m-60.gif": "8420",
	"./avatars/Shaman-draenei-m-70.gif": "215f",
	"./avatars/Shaman-orc-f-1.gif": "45a5",
	"./avatars/Shaman-orc-f-60.gif": "9d68",
	"./avatars/Shaman-orc-f-70.gif": "402a",
	"./avatars/Shaman-orc-m-1.gif": "e595",
	"./avatars/Shaman-orc-m-60.gif": "9df6",
	"./avatars/Shaman-orc-m-70.gif": "8abc",
	"./avatars/Shaman-tauren-f-1.gif": "386b",
	"./avatars/Shaman-tauren-f-60.gif": "730e",
	"./avatars/Shaman-tauren-f-70.gif": "7d06",
	"./avatars/Shaman-tauren-m-1.gif": "710e",
	"./avatars/Shaman-tauren-m-60.gif": "952a",
	"./avatars/Shaman-tauren-m-70.gif": "cedf",
	"./avatars/Shaman-troll-f-1.gif": "9357",
	"./avatars/Shaman-troll-f-60.gif": "412c",
	"./avatars/Shaman-troll-f-70.gif": "d428",
	"./avatars/Shaman-troll-m-1.gif": "d2c5",
	"./avatars/Shaman-troll-m-60.gif": "b505",
	"./avatars/Shaman-troll-m-70.gif": "0146",
	"./avatars/Warlock-bloodelf-f-1.gif": "d547",
	"./avatars/Warlock-bloodelf-f-60.gif": "ce76",
	"./avatars/Warlock-bloodelf-f-70.gif": "c1e6",
	"./avatars/Warlock-bloodelf-m-1.gif": "27a0",
	"./avatars/Warlock-bloodelf-m-60.gif": "436a",
	"./avatars/Warlock-bloodelf-m-70.gif": "edba",
	"./avatars/Warlock-gnome-f-1.gif": "74f4",
	"./avatars/Warlock-gnome-f-60.gif": "5180",
	"./avatars/Warlock-gnome-f-70.gif": "29c8",
	"./avatars/Warlock-gnome-m-1.gif": "66a0",
	"./avatars/Warlock-gnome-m-60.gif": "cd1f",
	"./avatars/Warlock-gnome-m-70.gif": "272f",
	"./avatars/Warlock-human-f-1.gif": "6dc1",
	"./avatars/Warlock-human-f-60.gif": "61bb",
	"./avatars/Warlock-human-f-70.gif": "4569",
	"./avatars/Warlock-human-m-1.gif": "15d1",
	"./avatars/Warlock-human-m-60.gif": "39eb",
	"./avatars/Warlock-human-m-70.gif": "7295",
	"./avatars/Warlock-orc-f-1.gif": "7934",
	"./avatars/Warlock-orc-f-60.gif": "285c",
	"./avatars/Warlock-orc-f-70.gif": "a57d",
	"./avatars/Warlock-orc-m-1.gif": "9976",
	"./avatars/Warlock-orc-m-60.gif": "7fe6",
	"./avatars/Warlock-orc-m-70.gif": "cc13",
	"./avatars/Warlock-undead-f-1.gif": "6368",
	"./avatars/Warlock-undead-f-60.gif": "1ba9",
	"./avatars/Warlock-undead-f-70.gif": "bbcc",
	"./avatars/Warlock-undead-m-1.gif": "258f",
	"./avatars/Warlock-undead-m-60.gif": "5917",
	"./avatars/Warlock-undead-m-70.gif": "4fa3",
	"./avatars/Warrior-draenei-f-1.gif": "f21d",
	"./avatars/Warrior-draenei-f-60.gif": "5043",
	"./avatars/Warrior-draenei-f-70.gif": "6a1f",
	"./avatars/Warrior-draenei-m-1.gif": "f43c",
	"./avatars/Warrior-draenei-m-60.gif": "d3eb",
	"./avatars/Warrior-draenei-m-70.gif": "e2ce",
	"./avatars/Warrior-dwarf-f-1.gif": "bc51",
	"./avatars/Warrior-dwarf-f-60.gif": "5486",
	"./avatars/Warrior-dwarf-f-70.gif": "4ba4",
	"./avatars/Warrior-dwarf-m-1.gif": "691d",
	"./avatars/Warrior-dwarf-m-60.gif": "20af",
	"./avatars/Warrior-dwarf-m-70.gif": "429e",
	"./avatars/Warrior-gnome-f-1.gif": "d4ba",
	"./avatars/Warrior-gnome-f-60.gif": "75e3",
	"./avatars/Warrior-gnome-f-70.gif": "df0a",
	"./avatars/Warrior-gnome-m-1.gif": "9913",
	"./avatars/Warrior-gnome-m-60.gif": "0383",
	"./avatars/Warrior-gnome-m-70.gif": "234e",
	"./avatars/Warrior-human-f-1.gif": "9e75",
	"./avatars/Warrior-human-f-60.gif": "4a96",
	"./avatars/Warrior-human-f-70.gif": "67fc",
	"./avatars/Warrior-human-m-1.gif": "fbd8",
	"./avatars/Warrior-human-m-60.gif": "b206",
	"./avatars/Warrior-human-m-70.gif": "2420",
	"./avatars/Warrior-nightelf-f-1.gif": "9aa6",
	"./avatars/Warrior-nightelf-f-60.gif": "c13e",
	"./avatars/Warrior-nightelf-f-70.gif": "593c",
	"./avatars/Warrior-nightelf-m-1.gif": "ffa7",
	"./avatars/Warrior-nightelf-m-60.gif": "4369",
	"./avatars/Warrior-nightelf-m-70.gif": "df41",
	"./avatars/Warrior-orc-f-1.gif": "af91",
	"./avatars/Warrior-orc-f-60.gif": "8a71",
	"./avatars/Warrior-orc-f-70.gif": "bf94",
	"./avatars/Warrior-orc-m-1.gif": "28010",
	"./avatars/Warrior-orc-m-60.gif": "7a8e",
	"./avatars/Warrior-orc-m-70.gif": "8165",
	"./avatars/Warrior-tauren-f-1.gif": "20ff",
	"./avatars/Warrior-tauren-f-60.gif": "90eb",
	"./avatars/Warrior-tauren-f-70.gif": "a287",
	"./avatars/Warrior-tauren-m-1.gif": "ec87",
	"./avatars/Warrior-tauren-m-60.gif": "84ef",
	"./avatars/Warrior-tauren-m-70.gif": "664b",
	"./avatars/Warrior-troll-f-1.gif": "a57e",
	"./avatars/Warrior-troll-f-60.gif": "58f7",
	"./avatars/Warrior-troll-f-70.gif": "b723",
	"./avatars/Warrior-troll-m-1.gif": "777f",
	"./avatars/Warrior-troll-m-60.gif": "35bf",
	"./avatars/Warrior-troll-m-70.gif": "c6b1",
	"./avatars/Warrior-undead-f-1.gif": "65b6",
	"./avatars/Warrior-undead-f-60.gif": "4b55",
	"./avatars/Warrior-undead-f-70.gif": "24cf",
	"./avatars/Warrior-undead-m-1.gif": "21a2",
	"./avatars/Warrior-undead-m-60.gif": "2716",
	"./avatars/Warrior-undead-m-70.gif": "37acd",
	"./avatars/default.gif": "af9d",
	"./avatars/goblin-f-70.gif": "41ca",
	"./avatars/goblin-m-70.gif": "54d7",
	"./avatars/pandarena-f-90.gif": "fed4",
	"./avatars/pandarena-m-90.gif": "d52b",
	"./avatars/pandarenh-f-90.gif": "2436",
	"./avatars/pandarenh-m-90.gif": "1cc3",
	"./avatars/pandarenn-f-1.gif": "665b",
	"./avatars/pandarenn-m-1.gif": "ec53",
	"./avatars/worgen-f-70.gif": "9d54b",
	"./avatars/worgen-m-70.gif": "c6c1",
	"./background.png": "9855",
	"./background_tirion.png": "3e75",
	"./class/1.gif": "fbed",
	"./class/11.gif": "5975",
	"./class/12.gif": "8fef",
	"./class/13.gif": "f711",
	"./class/14.gif": "93c8",
	"./class/15.gif": "f0bf",
	"./class/16.gif": "ddf9",
	"./class/17.gif": "410c",
	"./class/2.gif": "1f16",
	"./class/3.gif": "d3ef",
	"./class/4.gif": "768b",
	"./class/5.gif": "b060",
	"./class/6.gif": "c2db",
	"./class/7.gif": "0d24",
	"./class/8.gif": "8d78",
	"./class/9.gif": "9adb",
	"./cogwheel.jpg": "6af1",
	"./coins.png": "a83f",
	"./date.png": "be24",
	"./expansion.png": "0ec4",
	"./footer-background.jpg": "585f",
	"./frontpage/footer_background.jpg": "ac0f",
	"./frontpage/texture_dark.jpg": "6633",
	"./frontpage/texture_dark_2.jpg": "7d88",
	"./frontpage/texture_light.jpg": "f4d9",
	"./gear.png": "ae8c",
	"./gear_white.png": "870e",
	"./gravar_default.jpg": "0dab",
	"./horde.png": "64cb",
	"./horde_medium.png": "3120",
	"./horde_min.png": "01ec",
	"./item-border.png": "1e45",
	"./item-tooltip.png": "60e7",
	"./lightning.png": "826e",
	"./logo.png": "9d64",
	"./logo_big.png": "959e",
	"./mail-large.png": "9bfd",
	"./mail-medium.png": "a4d5",
	"./mail-small.png": "2b44",
	"./map.png": "8708",
	"./money-copper.gif": "4b78",
	"./money-gold.gif": "499f",
	"./money-silver.gif": "d43e",
	"./multi_chat_default.png": "ede3",
	"./nav_bg.jpg": "2fc2",
	"./paypal_checkout.png": "1252",
	"./paypal_checkout_button.png": "97ea",
	"./pencil.png": "c2d1",
	"./pvpstats.png": "06c4",
	"./race/1-0.gif": "1941",
	"./race/1-1.gif": "8aad",
	"./race/10-0.gif": "7b44",
	"./race/10-1.gif": "5f8f",
	"./race/11-0.gif": "14ca",
	"./race/11-1.gif": "8eec",
	"./race/12-0.gif": "2403",
	"./race/12-1.gif": "b68e",
	"./race/13-0.gif": "546e",
	"./race/13-1.gif": "3da2",
	"./race/14-0.gif": "ba5c",
	"./race/14-1.gif": "af27",
	"./race/2-0.gif": "3f44",
	"./race/2-1.gif": "30ba",
	"./race/3-0.gif": "8dd8",
	"./race/3-1.gif": "4bf9",
	"./race/4-0.gif": "a325",
	"./race/4-1.gif": "d5df",
	"./race/5-0.gif": "5775",
	"./race/5-1.gif": "5cd5",
	"./race/6-0.gif": "6cf7",
	"./race/6-1.gif": "e1b8",
	"./race/7-0.gif": "dfb3",
	"./race/7-1.gif": "b362",
	"./race/8-0.gif": "550a",
	"./race/8-1.gif": "0dd1",
	"./race/9-0.gif": "2c47",
	"./race/9-1.gif": "3ec7",
	"./rank.png": "d144",
	"./shield.png": "b942",
	"./user.png": "ba97",
	"./vote-sites/arena-top100.com.png": "ff76",
	"./vote-sites/gtop100.com.jpg": "7ed11",
	"./vote-sites/mmohub.com.jpg": "381a",
	"./vote-sites/top100arena.com.jpg": "5b16",
	"./vote-sites/topg.org.gif": "568a",
	"./vote-sites/topstatus.net.png": "957b",
	"./vote-sites/xtremetop100.com.jpg": "572f",
	"./world.png": "e76a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";